import React from "react";
import { UiSearchForm } from "../../component/_uiComponents/Forms/UiSearchForm";
import { UiActivityCommonEmpty } from "../../component/_uiComponents/ErrorMessages/UiActivitiesEmpty";

export const UiSelectBankEmpty = () => {
  return (
    <>
      <div className="df-choose-account df-choose-bank">
        <h2 className="df-popup-title">Select a Bank</h2>

        <UiSearchForm className="df-gray-bg" />

        <UiActivityCommonEmpty emptyTitle="No results found!" />
      </div>
    </>
  );
};
